import axiosLib from 'axios'
import Bus from '../bus/event-bus.js'

const axios = axiosLib.create({
	baseUrl: 'http://localhost:5815/'
})

axios.defaults.baseURL = process.env.API_URL;

axios.interceptors.request.use((config) => {
	Bus.$emit('loading', true)
	return config
}, (error) => {
	Bus.$emit('loading', false)
	return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
	Bus.$emit('loading', false)
	return response;
}, (error) => {
    Bus.$emit('loading', false)
    Bus.$emit('request.failed')
    return Promise.reject(error);
})

export default axios



// WEBPACK FOOTER //
// ./src/http/axios.js